import { Application, Feature, Functionality } from '@frontend/functionality/types';

/** Legacy non-wizard routes still used as shortcuts for some laundry flows. */
export function isOldScreen(app: Application | 'my', functionality: Functionality): string | null {
    if (app === 'my') {
        if (functionality.name.includes('laundry')) {
            if (functionality.feature === Feature.INBOUND_TRANSACTION) {
                return '/my/send_dirty_laundry';
            }
        }
    } else if (app === Application.LAUNDRY) {
        if (functionality.feature === Feature.INBOUND_TRANSACTION) {
            return '/laundry/receive_dirty_laundry';
        }
        if (functionality.feature === Feature.OUTBOUND_TRANSACTION) {
            return '/laundry/send_clean_laundry';
        }
        if (functionality.feature === Feature.SCANNER) {
            return '/laundry/open_scanner';
        }
    }

    return null;
}
